module.exports = __webpack_public_path__ + "img/endless-clouds-black.2b789d30.svg";